// extracted by mini-css-extract-plugin
export default {"wrapper":"zDFuU","container":"JicP3","content":"eqGLN","promocodeWrapper":"I9JEK","icon":"bE1jM","primary":"HBZ8k","copied":"V6VLb","secondary":"DnaSm"};